module.exports = "<div class=\"main-content\">\n  <div class=\"container-fluid\">\n      <div class=\"row\">\n          <div class=\"col-lg-8 col-lg-offset-2\">\n              <app-history></app-history>\n          </div>\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/iws/vanenet/src/app/main/history-page/history-page.component.html
// module id = ../../../../../src/app/main/history-page/history-page.component.html
// module chunks = main.module